import React from 'react';
import styles from './M_File.module.css';
import A_Tag from '@/components/A_Atoms/A_Tag/A_Tag';
import cn from 'classnames';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { formatFileSize } from '@/utils/formatters';

export interface M_FileProps {
  image: string;
  format: 'JPG' | 'JPEG' | 'PNG' | 'GIF' | 'MP3' | 'MP4' | 'WEBP' | 'MOV';
  size: number;
  mediaType?: 'image' | 'video' | 'audio' | 'gif';
  hasDescription?: boolean;
  onOpen: () => void;
  onDelete: () => void;
}

export default function M_File({
  image,
  format,
  size,
  mediaType = 'image',
  hasDescription = false,
  onOpen,
  onDelete,
}: M_FileProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.image_wrapper}>
        <img src={image} alt='File' />
        <A_Tag label={format} className={styles.format_tag} />
        <div className={styles.hover_wrapper}>
          <div className={styles.hover_buttons_wrapper}>
            <A_CircleButton
              icon={<Q_Icon.OpenedEyeIcon width={16} height={16} fill='none' />}
              variant='secondary'
              size='small'
              onClick={() => {
                onOpen();
              }}
            />
            <A_CircleButton
              icon={<Q_Icon.TrashIcon width={16} height={16} fill='none' />}
              variant='secondary'
              size='small'
              onClick={() => {
                onDelete();
              }}
            />
          </div>
          <p className={cn(styles.hover_text, 'text-caption')}>
            {format} {formatFileSize(size)}
          </p>
        </div>
      </div>
      <button
        className={cn(
          styles.button_wrapper,
          { [styles.button_wrapper_with_description]: hasDescription },
          'text-p-7'
        )}
        onClick={onOpen}
      >
        +Aa
        {hasDescription && (
          <Q_Icon.DescriptionIcon width={16} height={16} fill='currentColor' />
        )}
      </button>
    </div>
  );
}
